import { Logtail } from '@logtail/browser';

const token = import.meta.env.VITE_BETTERSTACK_SOURCE_TOKEN as string | undefined;

const logtail = token ? new Logtail(token) : null;

if (!token) {
  console.warn('[logger] VITE_BETTERSTACK_SOURCE_TOKEN not set — Better Stack logging disabled');
}

// ─── Override console methods ────────────────────────────────────────────────

const _log = console.log.bind(console);
const _warn = console.warn.bind(console);
const _error = console.error.bind(console);

console.log = (...args: unknown[]) => {
  _log(...args);
  logtail?.log(args.map(String).join(' '));
};

console.warn = (...args: unknown[]) => {
  _warn(...args);
  logtail?.warn(args.map(String).join(' '));
};

console.error = (...args: unknown[]) => {
  _error(...args);
  logtail?.error(args.map(String).join(' '));
};

// ─── Global error handlers ───────────────────────────────────────────────────

window.onerror = (message, source, lineno, colno, error) => {
  const msg = `[uncaught error] ${message} (${source}:${lineno}:${colno})`;
  _error(msg, error);
  logtail?.error(msg, {
    source: source ?? '',
    lineno: lineno ?? 0,
    colno: colno ?? 0,
    stack: error?.stack ?? '',
  });
};

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = `[unhandled rejection] ${reason instanceof Error ? reason.message : String(reason)}`;
  _error(msg, reason);
  logtail?.error(msg, {
    stack: reason instanceof Error ? reason.stack ?? '' : '',
  });
});

export { logtail };
